<template>
    <div>
        <div :class="{'Keikakumeisai_Details':true, 'Keikakumeisai_HanbaisakiBasicInfo':true, GrayUnderline: IsUnfold} " @click="(event)=>{event.stopPropagation(); this.IsUnfold = !this.IsUnfold; }">
            <div class="Keikakumeisai_IconUnfoldContainer"><img src="../assets/Icon_Unfold.svg" :class="{'Keikakumeisa_IconUnfolded': IsUnfold}" /></div>
            <div class="Keikakumeisai_HanbaisakiCostTitle" style="flex: 1;">{{ this.Label }}</div>
            <div style="flex: 1; place-content: end; display: flex;">{{ this.$FormatCurrency(Total) }}</div>
        </div>
        <div :class="{'Keikakumeisai_Details':true, 'Keikakumeisai_HanbaisakiDataContainer': true, Keikakumeisai_TotalDataContainer_Open: IsUnfold}" @click="(event)=>{event.stopPropagation();}">
            <div class="Keikakumeisai_TotalCostGroup">
                <CostItem v-for="item in CostItems" :key="item.label" :class="'GrayUnderline'" :CostName="item.label" :Cost="item.value"/>
            </div>
        </div>
    </div>
</template>

<script>
import CostItem from './KeikakumeisaiFoldableSubCostItem.vue'
export default
{
    components:
    {
        CostItem,
    },
    computed:{
        Total(){
            let result = 0;
            for (let i = 0; i < this.CostItems.length; i++)
            {
                result += this.CostItems[i].value;
            }

            return result;
        }
    },
    props:{
        Label: String,
        CostItems: Array
    },
    data(){
        return{
            IsUnfold: false,
        }
    }
}
</script>